/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircuitGroundDigital = createReactComponent(
  "circuit-ground-digital",
  "IconCircuitGroundDigital",
  [
    ["path", { d: "M12 13v-10", key: "svg-0" }],
    ["path", { d: "M12 21l-6 -8h12z", key: "svg-1" }]
  ]
);

export { IconCircuitGroundDigital as default };
//# sourceMappingURL=IconCircuitGroundDigital.js.map
